import { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import APIS from './components/apis';
import Maintenance from './components/common/Maintenance';
import Splash from './components/common/Splash';
import ErrorBoundary from './components/common/ErrorBoundary';
import './index.css';
import Account from './pages/Account';
import BettingRecord from './pages/BettingRecord';
import Deposit from './pages/Deposit';
import EXHome from './pages/EXHome';
import EXHomeVelki from './pages/EXHomeVelki';
import NineWiket from './pages/NineWiket';
import GameRun from './pages/GameRun';
import Games from './pages/Games';
import Home from './pages/Home';
import Login from './pages/Login';
import LuckySpain from './pages/LuckySpain';
import MakePayment from './pages/MakePayment';
import PasswordChange from './pages/PasswordChange';
import Profile from './pages/Profile';
import Promotion from './pages/Promotion';
import Referral from './pages/Refrral';
import Signup from './pages/Singup';
import Transaction from './pages/Transaction';
import Turnover from './pages/Turnover';
import VipCoin from './pages/VipCoin';
import Withdraw from './pages/Withdraw';
import StoreCode from './StoreCodeComponents';
import TermsAndConditions from './pages/TermsAndConditions';
import AboutUs from './pages/AboutUs';
import FAQ from './pages/FAQ';
import ContactUs from './pages/ContactUs'
import { hasSeoTitleApplied } from './utils/seo';

const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
function App() {
  const isDeviceMobile = true; // Force mobile view for testing  // ── /#/9wkt exit handler ─────────────────────────────────────────────────
  useEffect(() => {
    if (window.location.href.includes('/#/9wkt')) {
      const token = localStorage.getItem('token');
      fetch(`${process.env.REACT_APP_API_URL}/api/9wkt/exit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }).finally(() => {
        const cleanUrl = window.location.href.split('/#/9wkt')[0];
        window.location.replace(cleanUrl);
      });
    }
  }, []);
	const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
	const [showSplash, setShowSplash] = useState(true);
	const [logo, setLogo] = useState([]);
	const [isDataLoaded, setIsDataLoaded] = useState(false); 
	const location = useLocation();
	const [globalData, setGlobalData] = useState({});
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState('');
	const [balance, setBalance] = useState(0);
	const [refreshPvtData, setRefreshPvtData] = useState(false);
  const [color, setColor] = useState(false);
  const [pwaIconUrl, setPwaIconUrl] = useState(null);
  const [pwaSiteName, setPwaSiteName] = useState(null);


  // 🔁 Trigger private API refresh (used from header)
  const triggerPrivateRefresh = () => {
    setRefreshPvtData(prev => prev + 1);
  };

	const showAlert = (message = false) => { 
		if (!message) { 
			setShowModal(false);
			return;
		}
		setShowModal(true);
		setModalMessage(message);
	};
	


  // Function to dynamically set the favicon
  const setFavicon = (url) => {
    if (!url) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = url;
  };
  const [cssLoading, setCssLoading] = useState(false);

  // Fetch promotions data and set logo & favicon
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!response.ok) {
          throw new Error("Failed to fetch promotions");
        }
        const data = await response.json();
        setLogo(data[0].loader_logo);
        if (data[0]?.favicon) {
          const faviconUrl = data[0].favicon.startsWith('http')
            ? data[0].favicon
            : `${process.env.REACT_APP_API_URL}/storage/${data[0].favicon}`;
          setFavicon(faviconUrl);
          // prefer logo field if available, otherwise use favicon for PWA icon
          const pwaIcon = data[0]?.logo
            ? (data[0].logo.startsWith('http') ? data[0].logo : `${process.env.REACT_APP_API_URL}/storage/${data[0].logo}`)
            : faviconUrl;
          setPwaIconUrl(pwaIcon);
          localStorage.setItem('site_logo', pwaIcon || '');
        }
        console.log(data[0].loader_logo);
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    };

    fetchPromotions();
  }, []);

  // Fetch general site data
useEffect(() => {
	const fetchGeneral = async () => {
		let token = localStorage.getItem('token');
		let headers = {
			'Authorization': `Bearer ${token}`
		};
		if (!token) {
			headers = {};
		}
		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/general`, {
				headers: headers
			});
			if (!response.ok) {
				throw new Error("Failed to fetch General");
			}
			const data = await response.json();
			if (data) {
				const siteTitle = data[0]?.site_title;
				setPwaSiteName(siteTitle);
				console.log(siteTitle);
				localStorage.setItem('site_title', siteTitle || '');
				// Use the API title for the tab until a page applies its own SEO title.
				if (siteTitle && !hasSeoTitleApplied()) {
					document.title = siteTitle;
				}
				localStorage.setItem('whatsapp', data[0]?.whatsapp);
				localStorage.setItem('liveChat', data[0]?.live_chat);
				localStorage.setItem('intercom', data[0]?.intercom);
				localStorage.setItem('tawkId', data[0]?.tawk_id);
			}
		} catch (error) {
			console.error("Error fetching General:", error);
		}
	};

	fetchGeneral();
}, []);

// Dynamically update the PWA manifest once site name and icon are fetched
useEffect(() => {
  if (!pwaSiteName && !pwaIconUrl) return;
  const manifestData = {
    short_name: pwaSiteName || document.title,
    name: pwaSiteName || document.title,
    start_url: '/',
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff',
    icons: pwaIconUrl
      ? [
          { src: pwaIconUrl, sizes: '192x192', type: 'image/png' },
          { src: pwaIconUrl, sizes: '512x512', type: 'image/png' },
        ]
      : [],
  };
  const blob = new Blob([JSON.stringify(manifestData)], { type: 'application/json' });
  const manifestUrl = URL.createObjectURL(blob);
  let manifestLink = document.querySelector("link[rel='manifest']");
  if (!manifestLink) {
    manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    document.head.appendChild(manifestLink);
  }
  manifestLink.href = manifestUrl;
  return () => URL.revokeObjectURL(manifestUrl);
}, [pwaSiteName, pwaIconUrl]);

  // Monitor when both API calls are finished
  useEffect(() => {
    if (logo && document.title) {
      setIsDataLoaded(true); 
    }
  }, [logo]);

 
  useEffect(() => {
    if (isDataLoaded) {
      const splashTimeout = setTimeout(() => setShowSplash(false), 2500); 
      return () => clearTimeout(splashTimeout);
    }
  }, [isDataLoaded]);

  

  const fetchBalance = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/balance`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
  
        if (response.ok) {
			const data = await response.json();
		
			localStorage.setItem('balance', data.balance);
			if (document.querySelector('.mainBalance')) {
				document.querySelector('.mainBalance').innerHTML = data.balance;
			}
			
        } else if (response.status === 401) {
          handleLogout();
        }
      } catch (error) {
        console.error('Error fetching balance:', error);
      }
    } else {
      console.warn('No token found in local storage.');
    }
  }, []); 

  		useEffect(() => {
  const hostname = (window.location.hostname || '').toLowerCase();
  const origin = (window.location.origin || '').toLowerCase();
  const search = (window.location.search || '').toLowerCase();
  const params = new URLSearchParams(window.location.search);
  const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

  const is2nt666 = hostname.includes('2nt666') || origin.includes('2nt666') || brand.includes('2nt666');
  const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');


  const selectedBrand = is2nt666 ? '2nt666' : isLocalhost ? 'localhost' : 'default';

  localStorage.setItem('brand', selectedBrand);

  
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `${selectedBrand}.css?ver=${Date.now()}`;
  document.head.appendChild(link);

  setColor(is2nt666 || isLocalhost);

  return () => {
    const existing = document.querySelectorAll(`link[href*="${selectedBrand}.css"]`);
    existing.forEach(el => el.remove());
  };
}, []);
	
	

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    window.location.href = '/';
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchBalance();
      const interval = setInterval(fetchBalance, 10000);
      return () => clearInterval(interval);
    }
  }, [isLoggedIn, fetchBalance]);


  const PrivateRoute = ({ element }) => {
    return isLoggedIn ? element : <Navigate to="/login" />;
  };

  const [gtmId, setGtmId] = useState(null);

  // Google Tag Manager Integration
  useEffect(() => {
    const id = globalData?.general?.google_tag;
    if (!id) return;

    setGtmId(id);

    // Initialize dataLayer
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
    }

    // Remove any existing GTM script to prevent duplicates
    const oldScript = document.getElementById("gtm-script");
    if (oldScript) oldScript.remove();

    // Create and append GTM script
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);

    // Push gtm.start event to dataLayer
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // Cleanup on unmount
    return () => {
      const s = document.getElementById("gtm-script");
      if (s) s.remove();
    };
  }, [globalData]);



  // ✅ Main render
  return (
    <div className="App v-application v-application--is-ltr theme--dark" id='app'>

      {gtmId && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="gtm"
          ></iframe>
        </noscript>
      )}
        <APIS setGlobalData={setGlobalData} refreshPvtData={refreshPvtData} />
      {!isDataLoaded ? (
        <Splash onSplashComplete={() => setIsDataLoaded(true)} />
      ) : (
        <ErrorBoundary>
          <Routes>
       <Route
        path="/"
        element={
          globalData?.general?.site_status == 0 ? (
            <Maintenance />
          ) : (
            <Home globalData={globalData} />
          )
        }
      />
       <Route
        path="/promotion"
        element={
            <Promotion promotions={globalData.promotions?.allPromotions || []} globalData={globalData}  />
        }
      />
       <Route
        path="/login"
        element={
            <Login />
        }
      />
       <Route
        path="/signup"
        element={
            <Signup />
        }
      />
      <Route path="/gamerun" element={<PrivateRoute element={<GameRun />} />} />
      <Route
        path="/games"
        element={
            <Games globalData={globalData} />
        }
      />

      <Route path="/terms-and-conditions" element={<TermsAndConditions globalData={globalData} />} />
      <Route path="/about-us" element={<AboutUs globalData={globalData} />} />
      <Route path="/faq" element={<FAQ globalData={globalData} />} />
      <Route path="/contact-us" element={<ContactUs globalData={globalData} />} />

        <Route
        path="/account"
        element={
            <PrivateRoute element={<Account
              fetchBalance={fetchBalance}
							userData={globalData.userData}
							general={globalData.general || {}}          
							sociallink={globalData.socialLinks || {}}
              />}/>
        }
      />
      <Route path="/betting-record" element={<PrivateRoute element={<BettingRecord />} />} />
      <Route path="/ref-earn" element={<PrivateRoute element={<Referral showAlert={showAlert} userData={globalData.userData} />} />} />
      	<Route path="/exchange" element={<PrivateRoute element={<EXHome />} />} />
        <Route path="/velki" element={<PrivateRoute element={<EXHomeVelki />} />} />
        <Route path="/9wiket" element={<NineWiket />} />
      <Route path="/lucky-spain" element={<PrivateRoute element={<LuckySpain globalData={globalData}  />} />} />
      {/* <Route path="/rebet" element={<PrivateRoute element={<Rebate  globalData={globalData} />} />} /> */}
      <Route path="/vip" element={<PrivateRoute element={<VipCoin />} />} />
      <Route path="/deposit" element={<PrivateRoute element={<Deposit usdtRate={globalData?.general?.usdt_rate} hasEWallet={globalData.hasEWallet} userData={globalData.userData || []} transactionData={globalData.transactions || []} items={globalData.paymentMethods || []} promotions={globalData.promotions?.activePromotion || []} />} />} />
     	<Route path="/reset-password" element={<PrivateRoute element={<PasswordChange showAlert={showAlert} />} />} />
     	<Route path="/profile" element={<PrivateRoute element={<Profile showAlert={showAlert} />} />} />
      <Route path="/make-payment" element={<MakePayment hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } />} />
      <Route path="/withdrawal" element={<PrivateRoute element={<Withdraw general={globalData.general} hasEWallet={globalData.hasEWallet} userData={globalData.userData || [] } transactionData={globalData.transactions || [] } items={globalData.paymentMethods || []} />} />} />
      <Route path="/turnover" element={<PrivateRoute element={<Turnover  turnovers={globalData.turnovers || []} />} />} />
      <Route path="/transaction-record" element={<PrivateRoute element={<Transaction setRefreshPvtData={setRefreshPvtData} transactionData={globalData.transactions || [] } />} />} />
     	<Route path="/referral_code" element={<StoreCode codeType="referral_code" />} />
			<Route path="/affiliate_code" element={<StoreCode codeType="affiliate_code" />} />
			<Route path="/agent_code" element={<StoreCode codeType="agent_code" />} />

      {/* Catch-all: redirect unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
      )}
    </div>
  );
}

export default App;
